export default __webpack_public_path__ + "static/media/my-job-not-select-skyblue.d7344053.svg";